import React, { FunctionComponent } from 'react';

/**
 * Edit Icon
 */
const EditIcon: FunctionComponent<React.PropsWithChildren<{ color?: string }>> = ({
  color = 'black'
}) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7725 2C11.6058 2 11.4325 2.06667 11.3058 2.19333L10.0858 3.41333L12.5858 5.91333L13.8058 4.69333C14.0658 4.43333 14.0658 4.01333 13.8058 3.75333L12.2458 2.19333C12.1125 2.06 11.9458 2 11.7725 2ZM9.37248 6.01333L9.98581 6.62667L3.94581 12.6667H3.33248V12.0533L9.37248 6.01333ZM1.99915 11.5L9.37248 4.12667L11.8725 6.62667L4.49915 14H1.99915V11.5Z" // eslint-disable-line
        fill="black"
      />
    </svg>
  );
};

export default EditIcon;
